module.exports = __webpack_public_path__ + "img/Frente-73-01 on.88862524.png";